import classnames from 'classnames'
import Text from 'components/Text'
import Icon from 'components/Icon'
import './Tooltip.scss'

const Tooltip = ({
  iconId,
  title,
  description,
  accessibleTooltipId,
  position = 'bottom left',
}) => {
  return (
    <div className="tooltip" tabIndex={0}>
      <Icon
        iconId={iconId}
        className="tooltip__icon"
        aria-describedby={accessibleTooltipId}
      />
      <div
        className={classnames('tooltip-content', position?.split(/\s/g))}
        id={accessibleTooltipId}
        role="tooltip"
      >
        <Text p size={2} className="tooltip-content__title">
          {title}
        </Text>
        <Text p size={5}>
          {description}
        </Text>
      </div>
    </div>
  )
}

export default Tooltip
